<template>
  <learn-layout>
    <template v-slot:content>
      <v-col :cols="12">

        <div class="text-h6 pt-3">How to capture a Torvue</div>

        <v-alert type="info">
          We recommend you practice these steps a couple times at your home or office before trying to capture your first tour.
        </v-alert>

        <p>In the video below, we'll show you how to capture a Torvue.  This time, we'll interact with the camera directly instead of using a mobile phone, as many agents find it's easier.</p>
<!--        <p>The camera settings don't show up very well in the video, but they should look like the image below:</p>-->
<!--        <v-img :src="require('../../assets/camera.settings.webp')" max-height="250px" contain />-->

        <div class="embed-youtube">
          <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/cxqeBMkMHHg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>

        <br />
        <br />
        <p>You can view how the tour captured above turned out below:</p>
        <a href="https://mls.torvue.com?vid=xA7bvGXXKxkZHAuC2SCXZy" target="_blank"><v-img src="https://c.trvu.io/b5a93915-cb2d-4ac6-87a4-8a1e272ff11f/xA7bvGXXKxkZHAuC2SCXZy/torvueThumbnail.png" alt="2425 Demo Lane" /></a>


        <p class="pt-5">In the next step, we'll show you how to install the Torvue Uploader so you can send video files to Torvue for processing.</p>
      </v-col>
    </template>
    <template v-slot:footer>
      <div>
        <div class="caption font-italic">Previous step:</div>
        <v-btn class="float-end" color="secondary" outlined to="/learn/mobile" :small="$vuetify.breakpoint.smAndDown">
          <v-icon class="pr-2">mdi-arrow-left</v-icon>
          Phone setup
        </v-btn>
      </div>
      <v-spacer />
      <div>
        <div class="caption font-italic">Next step:</div>
        <v-btn class="float-end" color="primary" to="/learn/uploader" :small="$vuetify.breakpoint.smAndDown">
          Install Uploader
          <v-icon class="pl-2">mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </template>
  </learn-layout>
</template>

<script>
import LearnLayout from "@/components/LearnLayout.vue";

export default {
  name: "Capture",
  components: {LearnLayout}
}
</script>

<style scoped>

</style>